import React from 'react';
import Grid from '@material-ui/core/Grid';
import { CssBaseline } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
function ErrorUserDeactivated() {
    var t = useTranslation().t;
    return (React.createElement(Grid, { container: true, justify: "center", spacing: 2 },
        React.createElement(CssBaseline, null),
        React.createElement("div", { style: { textAlign: 'center', paddingTop: '120px' } },
            React.createElement("p", null,
                React.createElement("strong", null, t('Your user was deactivated'))),
            React.createElement("p", null,
                "Please contact support at 1-800-MICHELIN to correct this issue.",
                React.createElement("br", null),
                "Or try to login again:",
                ' ',
                React.createElement("a", { href: window.location.origin }, "here")))));
}
export default ErrorUserDeactivated;
//# sourceMappingURL=ErrorUserDeactivated.js.map